import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { useLanguage } from '../contexts/LanguageContext';

interface DayFilterContentProps {
  onSelectionChange: (selectedDays: string[]) => void;
  currentSelection: string[];
}

export default function DayFilterContent({ onSelectionChange, currentSelection }: DayFilterContentProps) {
  const { t } = useLanguage();
  const [selectedDay, setSelectedDay] = useState<string | null>(currentSelection[0] || null);

  const dayOptions = [
    { key: 'segunda', label: t('common.weekdays.long.monday') },
    { key: 'terça', label: t('common.weekdays.long.tuesday') },
    { key: 'quarta', label: t('common.weekdays.long.wednesday') },
    { key: 'quinta', label: t('common.weekdays.long.thursday') },
    { key: 'sexta', label: t('common.weekdays.long.friday') },
    { key: 'sábado', label: t('common.weekdays.long.saturday') },
    { key: 'domingo', label: t('common.weekdays.long.sunday') },
  ];

  const handleOptionPress = (dayKey: string) => {
    const newSelection = selectedDay === dayKey ? null : dayKey;
    setSelectedDay(newSelection);
  };

  // Expose the current selection to parent for when "Aplicar" is pressed
  useEffect(() => {
    onSelectionChange(selectedDay ? [selectedDay] : []);
  }, [selectedDay, onSelectionChange]);

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      {dayOptions.map((day) => (
        <TouchableOpacity
          key={day.key}
          style={[
            styles.optionCard,
            selectedDay === day.key && styles.selectedOptionCard
          ]}
          onPress={() => handleOptionPress(day.key)}
        >
          <Text style={styles.optionText}>
            {day.label}
          </Text>
          <View style={[
            styles.checkbox,
            selectedDay === day.key && styles.selectedCheckbox
          ]}>
            {selectedDay === day.key && (
              <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <Path 
                  d="M12.6654 4.7915L6.2487 11.2082L3.33203 8.2915" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
        </TouchableOpacity>
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    height: (68 * 5) + (8 * 4), // Exactly 5 options height + gaps between them
  },
  optionCard: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#F9F8F3',
    gap: 4,
    marginBottom: 8,
  },
  selectedOptionCard: {
    borderColor: '#004165',
    backgroundColor: '#E6EBF0',
  },
  optionText: {
    flex: 1,
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    color: '#151515',
    lineHeight: 19.6,
  },
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#7E7D75',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectedCheckbox: {
    borderWidth: 3,
    borderColor: '#015480',
    backgroundColor: '#015480',
    padding: 4,
  },
});